import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import LoyaltyInfoModal from '../../../components/modal/loyalty-info-modal/loyalty-info-modal';

class ActivityDashboardWelcomeMessage extends React.Component {
  static propTypes = {
    username: PropTypes.string
  };

  constructor (props) {
    super(props);

    this.state = {
      showModal: false
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal (e) {
    this.setState({
      showModal: !this.state.showModal
    });
  }

  renderLojaltyInfoModal () {
    if (this.state.showModal) {
      return <LoyaltyInfoModal close={this.toggleModal}/>;
    }
  }

  render () {
    return (
      <div className='dashboard-welcome-message-container'>
        <span className='dashboard-welcome-text'>
          <Translate content='DASHBOARD_GREETING_1' name={this.props.username} />
        </span>
        <span className='dashboard-welcome-text'>
          <Translate content='DASHBOARD_GREETING_2' />
        </span>
        <span className='dashboard-info-text'>
          <a href="#" onClick={this.toggleModal}>
            <Translate content='DASHBOARD_INFO_LINK' />
          </a>
        </span>
        {this.renderLojaltyInfoModal()}
      </div>
    );
  }
}

export default ActivityDashboardWelcomeMessage;



/** WEBPACK FOOTER **
 ** ./src/views/activities-view/welcome-message/activity-dashboard-welcome-message.js
 **/